<template>
    <ac-modal :title="title" ref="payeemodal">
        <div v-if="widgetReady">
            <div class="row">
                <div class="col-md-6 form-group">
                    <label>{{this.isPayer? "Payer" : "Payee"}} Name</label>
                    <small><span class="redText">required</span></small>
                    <input type="text" class="form-control" placeholder="Name" v-model="vm.name">
                </div>
                <div class="col-md-6 form-group">
                    <label>{{this.isPayer? "Payer" : "Payee"}} Email</label>
                    <input type="text" class="form-control" placeholder="Email" v-model="vm.email">
                </div>
                <div class="col-md-6" v-if="!isPayer">
                    <label>{{this.isPayer? "Payer" : "Payee"}} Transaction Fee</label>
                    <small><span class="redText">required</span></small>
                    <input type="text" class="form-control" placeholder="Transaction Fee" v-model="vm.accresaFee">
                </div>
                <div class="col-md-6">
                    <div style="padding-top: 30px;">
                        <input type="checkbox" class="form-check-input" :id="'editBanking'" v-model="editBanking" />
                        <label class="form-check-label" :for="'editBanking'">&nbsp;Edit Banking Information</label>
                    </div>
                </div>
                <div v-if="editBanking" class="col-md-12">
                    <hr/>
                    <ac-banking-info :saveBankingInfo="() => {}" :canSave="false" :show-required="true" v-model="vm.bankingInfo">

                    </ac-banking-info>
                </div>
                <div class="col-md-12">
                    <ac-button :action="save" class="btn btn-green btn-sm pull-right">
                        SAVE
                    </ac-button>
                    <ac-button :action="closeModal" class="btn btn-red btn-sm pull-right" style="margin-right: 5px;">
                        CANCEL
                    </ac-button>
                </div>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    //Based on company/components/BankAccountData.vue
    export default {
        name: "PayeeBankModal",
        mixins: [],
        data() {
            return {
                widgetReady: false,
                editBanking: false,
                vm: {},
                isPayer: false
            };
        },
        computed: {
            title() {
                return this.isPayer? 'Payer Manager' : 'Payee Manager';
            }
        },
        methods: {
            async showModal({payeeId, isPayer}) {
                this.widgetReady = false;
                this.isPayer = isPayer;
                // console.log("PayeeBankModal showModal payeeId:", payeeId);
                let data = await api.get('Fee', payeeId, 'GetPayee');
                this.mapData('vm', data);
                this.widgetReady = true;
                this.$refs.payeemodal.open();
            },
            async save() {
                this.vm.dontValidateBanking = !this.editBanking;
                let result = await api.post("Fee", `UpdatePayee/${!!this.isPayer}`, this.vm);
                if (result) {
                    this.$bus.$emit(this.$bus.$AcEvents.PAYEE_CHANGE, result);
                    this.closeModal();
                }
            },
            async closeModal() {
                this.$refs.payeemodal.close();
            },
        }
    }
</script>

<style scoped>

</style>